// Convert durations like "30s", "1m", "1h", "7d", "2w", or "1y" into seconds.
// "m" means minutes; months are intentionally unsupported because their length varies.
export function parseDurationToSeconds(value: string, fallbackSeconds: number): number {
	const trimmed = value.trim()
	if (!trimmed) {
		return fallbackSeconds
	}

	const numericSeconds = Number(trimmed)
	if (Number.isFinite(numericSeconds) && numericSeconds > 0) {
		return Math.floor(numericSeconds)
	}

	const match = trimmed.match(/^(\d+)([smhdwy])$/i)
	if (!match) {
		return fallbackSeconds
	}

	const amount = Number(match[1])
	const unit = match[2].toLowerCase()
	const secondsByUnit: Record<string, number> = {
		s: 1,
		m: 60,
		h: 60 * 60,
		d: 60 * 60 * 24,
		w: 60 * 60 * 24 * 7,
		y: 60 * 60 * 24 * 365,
	}

	return amount * secondsByUnit[unit]
}
